import PropTypes from 'prop-types';
import successIcon from '../../icons/success.svg';
import failedIcon from '../../icons/failed.svg';
import warningIcon from '../../icons/warning.svg';
import { DOMAIN_CHECK_STATUS } from '../../utils/domain-test-results';
import './DomainTestResults.css';

const STATUS_ICONS = {
    [DOMAIN_CHECK_STATUS.PASS]: { src: successIcon, alt: 'Passed' },
    [DOMAIN_CHECK_STATUS.WARN]: { src: warningIcon, alt: 'Warning' },
    [DOMAIN_CHECK_STATUS.FAIL]: { src: failedIcon, alt: 'Failed' },
};

/**
 * Results panel for the DNS records test, rendered below the DNS table.
 * The wording for the checks comes from the view model built by
 * buildDomainTestResults().
 * @param {object} props
 * @param {object} props.results - view model from buildDomainTestResults()
 */
function DomainTestResults({ results }) {
    if (!results) {
        return null;
    }

    return (
        <div className="domain-test-results" data-testid="domain-test-results">
            <header className="domain-test-results-header">DNS test results</header>
            <ul className="domain-test-results-checks">
                {results.checks.map((check) => {
                    const icon = STATUS_ICONS[check.status] || STATUS_ICONS.fail;

                    return (
                        <li
                            key={check.key}
                            className={`domain-test-check ${check.status}`}
                            data-testid={`domain-test-check-${check.key}`}
                        >
                            <img src={icon.src} alt={icon.alt} />
                            <div className="domain-test-check-body">
                                <p className="domain-test-check-title">{check.title}</p>
                                {check.detail && (
                                    <p className="domain-test-check-detail">{check.detail}</p>
                                )}
                                {check.fix && (
                                    <p
                                        className="domain-test-check-fix"
                                        data-testid="domain-test-check-fix"
                                    >
                                        {check.fix}
                                    </p>
                                )}
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

DomainTestResults.propTypes = {
    results: PropTypes.shape({
        allPassed: PropTypes.bool,
        checks: PropTypes.arrayOf(
            PropTypes.shape({
                key: PropTypes.string.isRequired,
                status: PropTypes.oneOf(Object.values(DOMAIN_CHECK_STATUS)).isRequired,
                title: PropTypes.string.isRequired,
                detail: PropTypes.string,
                fix: PropTypes.string,
            }),
        ).isRequired,
    }),
};

export default DomainTestResults;
